import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDropshippingSettings } from "~/api/dropshipping/queries";

/**
 * Custom hook that automatically syncs the application language with the user's dropshipping settings
 * This hook should be used at the application level to ensure language is set correctly across all pages
 */
export const useLanguageSync = () => {
  const { i18n } = useTranslation();
  const { data: dropshippingSettings } = useDropshippingSettings();

  useEffect(() => {
    if (dropshippingSettings?.language) {
      i18n.changeLanguage(dropshippingSettings.language);
    }
  }, [dropshippingSettings?.language, i18n]);

  return {
    currentLanguage: i18n.language,
    isLanguageLoaded: !!dropshippingSettings?.language,
  };
}; 